import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (location.hash === '#contact') {
      setTimeout(() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [location]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setOpenDropdown(null);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setOpenDropdown(null);
  };

  const handleDropdownToggle = (e, key) => {
    if (window.innerWidth <= 768) {
      e.preventDefault();
      setOpenDropdown(openDropdown === key ? null : key);
    }
  };

  const handleLogoClick = () => {
    closeMenu();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    closeMenu();
    if (location.pathname !== '/') {
      navigate('/#contact');
    } else {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <i className="fas fa-phone"></i>
            <span>+91 9348335684 / +91 7008306474</span>
            <i className="fas fa-envelope"></i>
            <span>maharajapolyfabpvtltd@gmail.com</span>
            <div className="social-links">
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
            </div>
          </div>
        </div>
      </div>

      <nav className="main-nav">
        <div className="container">
          <div className="nav-content">
            <div className="logo">
              <Link to="/" onClick={handleLogoClick}>
                <h2>MAHARAJA POLYFAB</h2>
              </Link>
            </div>

            <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
              <ul>
                <li><Link to="/" onClick={closeMenu}>Home</Link></li>
                <li className={`dropdown ${openDropdown === 'about' ? 'open' : ''}`}>
                  <Link to="/about/company-overview" onClick={(e) => handleDropdownToggle(e, 'about')}>About Us <i className="fas fa-chevron-down"></i></Link>
                  <ul className="dropdown-menu">
                    <li><Link to="/about/company-overview" onClick={closeMenu}><i className="fas fa-building"></i> Company Overview</Link></li>
                    <li><Link to="/about/directors" onClick={closeMenu}><i className="fas fa-users"></i> Our Directors</Link></li>
                    <li><Link to="/about/manufacturing" onClick={closeMenu}><i className="fas fa-industry"></i> Manufacturing Process</Link></li>
                    <li><Link to="/about/quality" onClick={closeMenu}><i className="fas fa-certificate"></i> Quality & Certification</Link></li>
                    <li><Link to="/about/factory-gallery" onClick={closeMenu}><i className="fas fa-images"></i> Factory Gallery</Link></li>
                  </ul>
                </li>
                <li className={`dropdown ${openDropdown === 'products' ? 'open' : ''}`}>
                  <Link to="/products" onClick={(e) => handleDropdownToggle(e, 'products')}>Products <i className="fas fa-chevron-down"></i></Link>
                  <ul className="dropdown-menu">
                    <li><Link to="/products" onClick={closeMenu}><i className="fas fa-box"></i> Core Products</Link></li>
                    <li><Link to="/products/bopp-laminated-bags" onClick={closeMenu}><i className="fas fa-layer-group"></i> BOPP Laminated Bags</Link></li>
                    <li><Link to="/products/pp-woven-bags" onClick={closeMenu}><i className="fas fa-th"></i> PP Woven Sacks/Bags</Link></li>
                    <li><Link to="/products/pp-rolls" onClick={closeMenu}><i className="fas fa-scroll"></i> PP Rolls</Link></li>
                    <li><Link to="/products/laminated-woven-bags" onClick={closeMenu}><i className="fas fa-cube"></i> Laminated Woven Bags</Link></li>
                    <li><Link to="/products/fibc" onClick={closeMenu}><i className="fas fa-archive"></i> FIBC</Link></li>
                  </ul>
                </li>
                <li className={`dropdown ${openDropdown === 'markets' ? 'open' : ''}`}>
                  <Link to="/markets/fmcg" onClick={(e) => handleDropdownToggle(e, 'markets')}>Markets Served <i className="fas fa-chevron-down"></i></Link>
                  <ul className="dropdown-menu">
                    <li><Link to="/markets/fmcg" onClick={closeMenu}>FMCG</Link></li>
                    <li><Link to="/markets/mining-minerals" onClick={closeMenu}>Mining & Minerals</Link></li>
                    <li><Link to="/markets/seed-crops" onClick={closeMenu}>Seed & Crops</Link></li>
                    <li><Link to="/markets/animal-nutrition" onClick={closeMenu}>Animal Nutrition</Link></li>
                    <li><Link to="/markets/construction" onClick={closeMenu}>Construction</Link></li>
                  </ul>
                </li>
                <li className={`dropdown ${openDropdown === 'investor' ? 'open' : ''}`}>
                  <Link to="/investor-relations" onClick={(e) => handleDropdownToggle(e, 'investor')}>Investor Relations <i className="fas fa-chevron-down"></i></Link>
                  <ul className="dropdown-menu">
                    <li><Link to="/investor-relations#agreements" onClick={closeMenu}><i className="fas fa-file-signature"></i> Contract Agreements</Link></li>
                    <li><Link to="/investor-relations#committees" onClick={closeMenu}><i className="fas fa-users-cog"></i> Committees Resolution</Link></li>
                    <li><Link to="/investor-relations#policies" onClick={closeMenu}><i className="fas fa-book"></i> Policies</Link></li>
                    <li><Link to="/investor-relations#ipo" onClick={closeMenu}><i className="fas fa-chart-line"></i> Initial Public Offering</Link></li>
                    <li><Link to="/investor-relations#advertisement" onClick={closeMenu}><i className="fas fa-image"></i> Advertisement</Link></li>
                  </ul>
                </li>
                <li><Link to="/i-am-recyclable" onClick={closeMenu}>I Am Recyclable</Link></li>
                <li><Link to="/#contact" onClick={handleContactClick}>Contact Us</Link></li>
              </ul>
            </div>

            <div className="nav-toggle" onClick={toggleMenu}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
